import React, {useEffect} from 'react';
// import styles from '../homepage.module.css'
import styles from './intro.module.css'
import {useTranslation} from "react-i18next";
import LazyText from "../../common/imagescroll/LazyText";
// import Lazy from "../../../common/lazy-scroll/Lazy";
// import {HOME_PAGE_CONTENT} from "../homePageContent";

const Intro: React.FC = () => {

    const { t, i18n } = useTranslation(); // Use the translation hook

    const pageTitle = "Custom Web Development, Software & Design Solutions in Kanata - XSCI";
    const metaDescriptionContent = "XSCI specializes in custom web development, responsive design, and software solutions in Kanata. " +
        "We help businesses grow with scalable, high-performing web apps and modern digital solutions. Get started with a custom project today!";
    // Set the meta description
    let metaDescription = document.querySelector("meta[name='description']") as HTMLMetaElement;

    // The content you're trying to use for the meta description
    const descriptionContent = metaDescriptionContent;

    useEffect(() => {
        document.title = pageTitle;

        // Set the meta description
        let metaDescription = document.querySelector("meta[name='description']") as HTMLMetaElement;

        // The content you're trying to use for the meta description
        const descriptionContent = metaDescriptionContent;

        if (metaDescription) {
            metaDescription.setAttribute("content", descriptionContent); // Correctly set the content
        } else {
            metaDescription = document.createElement("meta") as HTMLMetaElement;
            metaDescription.name = "description";
            metaDescription.content = descriptionContent;
            document.head.appendChild(metaDescription);
        }
    }, []);


    return (
        <section className={styles.section_container}>
            <div className={styles.content_wrapper}>
                <div className={styles.image_container}>
                    <img
                        src={"/images/home/intro_4.jpg"}
                        className={styles.image}
                        alt="Banner background"/>
                </div>
                <div className={styles.text_content}>
                    <LazyText>

                        <h2 className={styles.section_title}>
                            {String(t('homePage.valuePropositionTitle'))}
                        </h2>
                        <p className={styles.intro_paragraph}>
                            {String(t('homePage.valueProposition'))}
                        </p>
                    </LazyText>

                </div>

            </div>
        </section>
    );
};

export default Intro;
